import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { AIPage } from './pages/AIPage';
import { GameDevPage } from './pages/GameDevPage';
import { AvionicsPage } from './pages/AvionicsPage';
import { TeachAndLearnPage } from './pages/TeachAndLearnPage';
import { ContactPage } from './pages/ContactPage';
import { I18nProvider } from './contexts/I18nContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';

function AppContent() {
  return (
    <Router>
      <div className="app">
        <Header />

        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ai" element={<AIPage />} />
            <Route path="/gamedev" element={<GameDevPage />} />
            <Route path="/avionics" element={<AvionicsPage />} />
            <Route path="/teachandlearn" element={<TeachAndLearnPage />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* convenience aliases */}
            <Route path="/kontakt" element={<Navigate to="/contact" replace />} />
            <Route path="/teach" element={<Navigate to="/teachandlearn" replace />} />
            <Route path="/games" element={<Navigate to="/gamedev" replace />} />
            <Route path="/drones" element={<Navigate to="/avionics" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AppContent />
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
